import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Card, Form, Input, message, Modal, Popconfirm, Spin } from 'antd';
import { Route, Switch } from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import Report from './report';
import View from './view';
import {
  addNewImage, addNewPVImage,
  checkResource,
  clearPropsData,
  createResource,
  createResourceWithDocuments,
  deleteResource,
  downloadPVCombineReport,
  downloadViewReport,
  fetchResource,
  getPVCombineReport,
  getResource,
  getResourceForDownload,
  handleSelectAssetSubType,
  handleSelectAssetType, processQrResetForPV,
  reOpenPvVerification,
  saveResourceQuery,
  submitReport,
  updateResource,
  updatePvAssetDetailField,
  removePvAssetDetail,
  updateTempCode
} from '../../appRedux/actions/PreVerification';
import {
  checkQrAlreadyUsed,
  fetchFilter,
  fetchSubDocumentFilter,
  getSpareInventoryFilters,
  searchAssetParameter,
  bulkApproveWithDefaultValue, getBackgroundJobStatus
} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import { getAll as getAllTagTypes } from "../../appRedux/actions/AssetTagType";
import * as _ from 'lodash';
import CombineReport from "./CombineReport";
import BulkApproval from "../PreVerificationApproval/bulkApproval";
import BulkQrReset from "./bulkQrReset";
import QrResetButton from "./QRResetButton";

export class PreVerification extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: [],
    resourceData: [],
    lastTagType: null,
    showBulkApprove: false,
    bulkApprovalPv: null,
    activeApprovalPvId: null,
    showQRResetView: false,
    pvQrResetId: null,
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);

    const tagType = localStorage.getItem("last_tag_type");
    // console.log(tagType)
    if (tagType)
      this.setState({ lastTagType: JSON.parse(tagType) });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({
        visibleColumns: columns
      }, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
    if (nextProps && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({ resourceData: nextProps.data });
    }

  }

  componentWillUnmount() {
    // console.log(`Unmount ...`);
    this.storeLastTagType();
  }

  handleColumnChange = (value, array) => {
    const { filters } = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = { ...this.props.query };
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = { ...this.props.query };
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = { ...this.props.query };
    query.pagination = { ...query.pagination, current: pagination.current };
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  };

  handleBulkApprove = (record) => {
    // console.log(record)
    if (record) {
      this.props.fetchResource(record)
      this.setState({ showBulkApprove: true, bulkApprovalPv: record })
    }
  }

  // Called by the BulkApproval modal as its background job starts/finishes, so the row-level
  // Approve button for that PV stays disabled until the job is no longer in flight. Columns are
  // cached in state, so rebuild them after the flag changes to re-evaluate the button's disabled.
  handleApprovalJobRunningChange = (pvId, running) => {
    const nextPvId = running ? pvId : null;
    if (this.state.activeApprovalPvId === nextPvId) {
      return;
    }
    this.setState({ activeApprovalPvId: nextPvId }, () => {
      this.renderColumns(this.props.filters, this.state.visibleColumns);
    });
  }

  handlePVQrReset = (record) => {
    // console.log(record)
    if (record) {
      this.props.fetchResource(record)
      this.setState({ showQRResetView: true, pvQrResetId: record })
    }
  }

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;

    Object.keys(filters).forEach((item) => {

      if (item === '_id') {
        return;
      }

      if (selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      width: '15vw',
      render: (record, ...data) => (
        <div>
          {
            record && record.status === 'COMPLETED' ?
              <AccessControl resource={this.props.resourceName} permissionNeeded={'report'}
                roles={this.props.authUser ? this.props.authUser.roles : []}
                render={(props) => {
                  return <Button type="primary" style={{ marginRight: '10px' }} size='small'
                    onClick={() => this.report(record._id)}>Report</Button>
                }} /> : ''
          }
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Button.Group>
                <Button type="primary" size='small'
                  onClick={() => this.view(record._id)}>View</Button>
                <Button size='small'
                  onClick={() => this.report(record._id, 'csv')}>CSV</Button>
              </Button.Group>
            }} />

          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={() => {
                  this.deleteResource(record._id)
                }}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
                disabled={record && record.isApproved}
              >
                <Button style={{ marginLeft: '5px' }} type="danger" size='small'
                  disabled={!(record &&
                    (!record.isApproved && record.status !== 'COMPLETED'
                      && record.status !== 'SUBMITTED'))}>
                  Delete
                </Button>
              </Popconfirm>
            }} />

          <AccessControl resource={'PreVerificationApproval'} permissionNeeded={'c'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              // Approval is disabled for now: new assets are created from
              // reconciliation only, so PVs are not approved from this list.
              return <Button style={{ marginLeft: '5px' }} type="default" size='small'
                disabled
                onClick={() => this.handleBulkApprove(record._id)}>Approve</Button>
            }} />
          <AccessControl resource={this.props.resourceName} permissionNeeded={'c'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <QrResetButton handlePVQrReset={this.handlePVQrReset} pvId={record._id} />
            }} />

        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values, update = false) => {
    this.props.createResource(values, update);
  };

  createResourceWithDocuments = (values, checked, update = false, secondUpdate = false, save = false) => {
    this.props.createResourceWithDocuments(values, checked, update, secondUpdate, save);
  };

  updateResource = (values, id, checked, update = false, save = false) => {
    this.props.updateResource(values, id, checked, update, save);
  };

  submitReport = (id) => {
    this.props.submitReport(id);
  }

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  reOpenPvVerification = (id) => {
    this.props.reOpenPvVerification(id);
  };

  create = () => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  view = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/view/${id}`);
  };

  report = (id, type) => {
    const { match } = this.props;
    if (type === 'csv') {
      this.props.downloadViewReport(id);
    } else {
      this.props.history.push(`${match.url}/difference-report/${id}`);
    }
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "PreVerification");
  }

  updateTempCode = (id, payload, checked, update) => {
    this.props.updateTempCode(id, payload, checked, update);
  }

  handleTagTypeChange = (typeId) => {
    console.log(typeId);
    const selectedTagType = this.props.allTagTypes.filter(tag => tag._id === typeId)[0]
    console.log(selectedTagType);
    if (!this.state.lastTagType || (this.state.lastTagType._id !== typeId)) {
      this.setState({
        lastTagType: selectedTagType
      })
    }
  }

  storeLastTagType = () => {
    if (this.state.lastTagType) {
      // console.log('Setting last tag ...')
      localStorage.setItem('last_tag_type', JSON.stringify(this.state.lastTagType));
    }
  }

  toggleBulkApprovalShow = () => {
    this.setState({
      showBulkApprove: !this.state.showBulkApprove
    })
  }

  toggleQrResetShow = () => {
    this.setState({
      showQRResetView: !this.state.showQRResetView
    })
  }

  render() {
    const {
      match,
      data,
      resource,
      edit,
      fetchResource,
      loading,
      filters,
      modules,
      authUser,
      resourceName
    } = this.props;
    const { columns, visibleColumns } = this.state;
    // console.log(edit)
    // console.log(filters)
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>{sanitizeFieldName(resourceName)}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
          render={() => <List columns={columns}
            data={data}
            clearFilter={this.clearAll}
            filters={filters}
            handleChange={this.handleChange}
            columnChange={this.handleColumnChange}
            downloadToCSV={this.downloadToCSV}
            title={resourceName}
            size={'middle'}
            create={this.create}
            pagination={this.props.query.pagination}
            loading={loading}
            authUser={authUser}
            visibleColumn={visibleColumns}
          />
          } />
        <Route path={`${match.url}/add`}
          render={(props) => <Create
            tempAssetCodeData={this.props.data}
            filters={filters}
            record={this.props.record}
            subDocumentFilters={this.props.subDocumentFilters}
            match={match}
            onTempCodeUpdate={this.updateTempCode} //
            assetSubTypes={this.props.assetSubTypes}
            clearData={this.props.clearPropsData}
            handleSelectAssetType={this.props.handleSelectAssetType}
            assetModels={this.props.assetModels}
            handleSelectAssetSubType={this.props.handleSelectAssetSubType}
            tempCodeData={this.props.resource}
            history={this.props.history}
            onCheck={this.props.checkResource}
            modules={modules}
            title={'CREATE'}
            resource={resourceName}
            onChange={this.handleFormChange}
            onUpdate={this.updateResource}
            warning={this.props.warning}
            onSubmit={this.createResource} //
            onSubmitWithDocument={this.createResourceWithDocuments}
            loading={loading}
            viewEarlier={this.view}
            searchAssetParameter={this.props.searchAssetParameter}
            assetParameterData={this.props.assetParameterData}
            qrUsed={this.props.qrUsed}
            checkQrAlreadyUsed={this.props.checkQrAlreadyUsed}
            allTagTypes={this.props.allTagTypes}
            getAllTagTypes={this.props.getAllTagTypes}
            lastTagType={this.state.lastTagType}
            handleTagTypeChange={this.handleTagTypeChange}
            width={this.props.width}
            {...props}
          />
          } />
        <Route path={`${match.url}/edit/:id`}
          render={(props) => <Create data={edit}
            filters={filters}
            modules={modules}
            tempCodeData={this.props.resource}
            title={'EDIT'}
            clearData={this.props.clearPropsData}
            match={match}
            assetSubTypes={this.props.assetSubTypes}
            assetModels={this.props.assetModels}
            handleSelectAssetType={this.props.handleSelectAssetType}
            handleSelectAssetSubType={this.props.handleSelectAssetSubType}
            tempAssetCodeData={this.props.data}
            history={this.props.history}
            resource={resourceName}
            fetch={fetchResource}
            onChange={this.handleFormChange}
            onTempCodeUpdate={this.updateTempCode}
            warning={this.props.warning}
            onUpdate={this.updateResource}
            onSubmit={this.createResource}
            onCheck={this.props.checkResource}
            onSubmitWithDocument={this.createResourceWithDocuments}
            viewEarlier={this.view}
            searchAssetParameter={this.props.searchAssetParameter}
            assetParameterData={this.props.assetParameterData}
            loading={loading}
            authUser={authUser}
            qrUsed={this.props.qrUsed}
            checkQrAlreadyUsed={this.props.checkQrAlreadyUsed}
            allTagTypes={this.props.allTagTypes}
            getAllTagTypes={this.props.getAllTagTypes}
            width={this.props.width}
            lastTagType={this.state.lastTagType}
            handleTagTypeChange={this.handleTagTypeChange}
            {...props}
          />
          } />
        <Route path={`${match.url}/view/:id`}
          render={(props) => <View data={edit}
            filters={filters}
            modules={modules}
            title={'VIEW'}
            clearData={this.props.clearPropsData}
            match={match}
            history={this.props.history}
            resource={resourceName}
            warning={this.props.warning}
            onCheck={this.checkResource}
            fetch={fetchResource}
            viewEarlier={this.view}
            onChange={this.handleFormChange}
            onSubmit={this.updateResource}
            submitReport={this.submitReport}
            reOpenPvVerification={this.reOpenPvVerification}
            loading={loading}
            authUser={authUser}
            onSubmitWithDocument={this.props.addNewPVImage}
            onUpdateAssetDetailField={this.props.updatePvAssetDetailField}
            onRemoveAssetDetail={this.props.removePvAssetDetail}
            {...props}
          />
          } />
        <Route path={`${match.url}/difference-report/:id`}
          render={(props) => <Report data={edit}
            filters={filters}
            modules={modules}
            title={'VIEW'}
            clearData={this.props.clearPropsData}
            match={match}
            history={this.props.history}
            resource={resourceName}
            fetch={fetchResource}
            onChange={this.handleFormChange}
            onSubmit={this.updateResource}
            loading={loading}
            {...props}
          />
          } />

        <Route path={`${match.url}/report`}
          render={(props) => <CombineReport data={null}
            filters={filters}
            modules={modules}
            title={'Report'}
            clearData={null}
            match={match}
            history={this.props.history}
            resource={resourceName}
            fetch={null}
            onChange={null}
            onSubmit={null}
            loading={loading}
            fetchLocSubLoc={this.props.getSpareInventoryFilters}
            locationData={this.props.locationsData}
            subLocationData={this.props.subLocationsData}
            fetchReportData={this.props.getPVCombineReport}
            combineReportData={this.props.combineReportData}
            downloadCombineData={this.props.downloadPVCombineReport}
            {...props}
          />
          } />
      </Switch>

      <BulkApproval showBulkApprove={this.state.showBulkApprove}
        toggleBulkApprovalShow={this.toggleBulkApprovalShow} pvData={edit} loading={loading}
        ownerData={filters && filters['owner_data'] && filters['owner_data']['data'] && filters['owner_data']['data']['data'] || []}
        pvId={this.state.bulkApprovalPv} processApproval={this.props.bulkApproveWithDefaultValue}
        bulkProcessJob={this.props.bulkProcessJob}
        onJobRunningChange={this.handleApprovalJobRunningChange} />

      <BulkQrReset showQRResetView={this.state.showQRResetView}
        toggleQRResetView={this.toggleQrResetShow} pvData={edit} loading={loading}
        pvId={this.state.pvQrResetId} processQRReversal={this.props.processQrResetForPV}
        qrResetProcessJob={this.props.pvQrResetJob} />
    </div>)
  }
}

const mapStateToProps = ({
  auth,
  settings,
  preVerification,
  preVerificationApproval,
  commonData,
  spareInventoryReport,
  assetTagType
}) => {
  return {
    width: settings.width,
    authUser: auth.authUser,
    total: preVerification.total,
    data: preVerification.resources,
    resource: preVerification.resource,
    assetSubTypes: preVerification.assetSubTypes,
    assetModels: preVerification.assetModels,
    record: preVerification.record,
    edit: preVerification.edit,
    query: preVerification.query,
    warning: preVerification.warning,
    astUploadCount: preVerification.astUploadCount,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    subDocumentFilters: commonData.subDocumentFilters,
    locationsData: spareInventoryReport.locations,
    subLocationsData: spareInventoryReport.subLocations,
    combineReportData: preVerification.combineReportData,
    assetParameterData: commonData.assetParameterSearchData,
    qrUsed: commonData.qrUsed,
    allTagTypes: assetTagType.allTypes,
    backgroundJobStatus: commonData.backgroundJobStatus,
    bulkProcessJob: preVerificationApproval.bulkProcessJob,
    pvQrResetJob: preVerification.pvQrResetJob,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    createResourceWithDocuments,
    addNewPVImage,
    fetchResource,
    updateResource,
    updateTempCode,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    fetchSubDocumentFilter,
    clearPropsData,
    submitReport,
    checkResource,
    handleSelectAssetType,
    handleSelectAssetSubType,
    reOpenPvVerification,
    getSpareInventoryFilters,
    getPVCombineReport,
    downloadPVCombineReport,
    searchAssetParameter,
    downloadViewReport,
    checkQrAlreadyUsed,
    getAllTagTypes,
    bulkApproveWithDefaultValue,
    getBackgroundJobStatus,
    processQrResetForPV,
    updatePvAssetDetailField,
    removePvAssetDetail
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(PreVerification);
